/**
 * 聚合应用内应用组件
 *
 * created by liyaoh 2021-06-16
 */
import React from "react";
import { DragSource, DropTarget } from "react-dnd";
import { connect } from "react-redux";
import { setDraggingItems, setDraggingAppGroupItem } from "Store/GridLayout/action";
import { setGridDroppable, DragTypes, checkApp, getSpecialColor, getAppGroupOrderType, APPGROUPCONSTANT } from "../utilService";
import { useOprArea, withQuickLaunchArea } from "../hooks";
import { AppForIcon } from "../CreaterForApp/index";
import NoAuthority from "Components/NoAuthority";
import CreaterForWidget from "../CreaterForWidget";
import ExternalLinks from "Widgets/ExternalLinks";
import { getCurrentLangText } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
const { PubSub, base } = platform;
const { NCTooltip } = base;
const cardSource = {
    beginDrag(props, monitor, component) {
        const { item } = props;
        const dragData = {
            type: DragTypes.APP_GROUP_ITEM,
            id: item.cardid,
            appGroupId: props.appGroupId,
            index: props.index,
            cardList: [item],
        };
        setGridDroppable(false); //开始拖拽发事件禁用GridLayout的droppable
        if (item.appcode) {
            props.setDraggingItems({
                from: DragTypes.APP_GROUP_ITEM,
                data: [item],
            }); //设置draggingItems
        }
        props.setDraggingAppGroupItem(dragData);
        return dragData;
    },
    canDrag(props) {
        const { groupItem, activeTab } = props;
        return props.editable && !checkApp(groupItem).isQuickLaunch && activeTab !== APPGROUPCONSTANT.RECENTVISIT; // 快速发起 常用应用的最近访问都不能拖拽
    },
    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return;
        }
        setGridDroppable(true); //结束拖拽发事件恢复GridLayout的droppable
        const dragItem = monitor.getItem();
        const dropResult = monitor.getDropResult();
        //跨组拖拽成功删除dragItem
        if (dropResult.moved && dropResult.appGroupId !== dragItem.appGroupId) {
            props.appGroupAction.remove(dragItem.index, true);
        }
    },
};
const cardTarget = {
    canDrop(props, monitor) {
        const { groupItem, activeTab } = props;
        if (checkApp(groupItem).isQuickLaunch || activeTab === APPGROUPCONSTANT.RECENTVISIT) {
            // 快速发起 常用应用的最近访问都不能拖拽
            return false;
        }
        // You can disallow drop based on props or item
        const dragItem = monitor.getItem();
        return !(dragItem.appGroupId === props.appGroupId && dragItem.index === props.index);
    },
    drop(props, monitor, component) {
        const { appGroupAction } = props;
        let moved = true;
        const dragItem = monitor.getItem();
        //聚合应用内部移动
        if (dragItem.appGroupId === props.appGroupId) {
            appGroupAction.move(dragItem.index, props.index);
        } else {
            //从左侧拖拽设置拖拽成功回调
            props.dragFromLeftComplete(dragItem);
            // component.setState({ dropCompleteFlag: true })
            const newItems = props.addApps(
                { from: dragItem.type, data: dragItem.cardList },
                props.index,
            );
            moved = newItems.length > 0;
        }
        PubSub.publish("onRemoveGridLayoutPlaceholder"); //清除GridLayout的placeholder
        return { type: DragTypes.APP_GROUP_ITEM, moved, appGroupId: props.appGroupId };
    },
    // hover(props, monitor) {
    //     const dragItem = monitor.getItem();
    //     const { appGroupAction, index, appGroupId, item } = props;
    //     let dragItemIndex = dragItem.index;
    //     if (dragItem.appGroupId === appGroupId) {
    //         if (dragItem.cardList[0].appid !== item.appid) {
    //             // 如果 source item 与 target item 不同，则交换位置并重新排序
    //             appGroupAction.move(dragItemIndex, index);
    //         }
    //     }
    // }
};
class AppItem extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.dropCompleteFlag) {
            this.setState({ dropCompleteFlag: true });
        }
    }
    state = {
        dropCompleteFlag: false,
        showTip: false,
    }
    //点击item 编辑态禁用点击事件
    handleItemClick = this.props.editable
        ? () => { }
        : () => {
            const { item, groupItem } = this.props;
            if (checkApp(groupItem).isQuickLaunch) { // 快速发起小部件内的
                if (item.quicklaunchtype == '3') { // 外部链接
                    window.open(item.target_path, '_blank');
                } else if (item.quicklaunchtype == '1') { // 应用
                    let openType, pageParams;
                    if (item.displaytype == '1') { // 弹窗
                        openType = 'modal';
                        pageParams = { modalTitle: getCurrentLangText('title', item), hideNav: true, modalSize: item.windowsize || 'max' };
                    }
                    this.openApp(openType, item.openparam, pageParams, false);
                }
                return;
            }

            this.openApp();
        };
    openApp(openType, urlParams, pageParams, recordRecent) {
        const appData = JSON.parse(JSON.stringify(this.props.item));
        if (appData.code) {
            appData.menuitemcode = appData.code; //传菜单编码
        }
        window.openNew(appData, openType, null, {
            urlParams,
            pageParams,
            recordRecent,
        });
    }

    //外部链接从左侧直接拖到聚合应用内
    handleAddWidgetComplete = (data = {}) => {
        const { item } = this.props;
        if (!data) {return;}
        // setDropCompleteFlag(fasle);
        this.setState(false);
        //新增外部链接把返回id赋值给cardid
        if (checkApp(item).isExternalLink && data) {
            this.props.appGroupAction.updateAppProperties(item.cardid, {
                cardid: data.pk_group_app,
                pk_group_app: data.pk_group_app,
            });
        }
    };
    renderItem = () => {
        const { editable, item, groupItem, onEdit, onDelete, relateidObj, themeType, isQuickLaunchAndAdaptive } = this.props;
        let orderType = null;
        if (checkApp(groupItem).isCommonUsedApp) {
            // 常用链接
            orderType = getAppGroupOrderType(groupItem.sideData && groupItem.sideData.cardArrangement && groupItem.sideData.cardArrangement);
        }
        if (checkApp(groupItem).isQuickLaunch) {
            const isWidget = item.quicklaunchtype == '2'; // 部件
            const itemTitle = getCurrentLangText('title', item);
            const { showTip } = this.state;
            return <div className={`quick-launch-item ${isWidget ? 'widget' : ''}`} style={{
                background: isWidget ? 'none' : getSpecialColor(item.bgcolor, themeType),
                height: isQuickLaunchAndAdaptive ? '100%' : '48px',
            }}>
                {
                    isWidget
                        ?
                        <CreaterForWidget key={item.cardid} appOption={item} {...this.props} />
                        :
                        <React.Fragment>
                            <img className="item-icon" src={item.icon}></img>
                            <NCTooltip
                                placement="right"
                                overlay={showTip ? itemTitle : ''}
                                inverse
                            >
                                <span onMouseEnter={e => {
                                    const tipNode = e.target;
                                    if (tipNode) {
                                        if (tipNode.scrollWidth > tipNode.clientWidth) {
                                            !showTip && this.setState({ showTip: true });
                                        } else {
                                            showTip && this.setState({ showTip: false });
                                        }
                                    }
                                }} className="item-title">{itemTitle}</span>
                            </NCTooltip>
                        </React.Fragment>
                }
                {/* 编辑和删除功能放在侧拉了，这里不需要 */}
                {/* {
                    editable &&<div className="operation" onClick={() => { event.stopPropagation(); }}>
                        {
                            relateidObj.code == 0 && <i className="iconfont icon-shanchu" onClick={ onDelete }></i>
                        }
                        <i className="iconfont icon-bianji" onClick={ onEdit }></i>
                    </div>
                } */}
                {/* 1表示没权限 */}
                {item.appperm == 1 && <NoAuthority />}
            </div>;
        }

        //外部链接
        if (checkApp(item).isExternalLink) {
            return (
                <ExternalLinks
                    defaultName={item.name}
                    isDefaultStyle={false}
                    editable={editable}
                    id={item.cardid}
                    isAddComplete={this.props.dropCompleteFlag}
                    onAddWidgetComplete={this.handleAddWidgetComplete}
                    orderType={orderType}
                    {...this.props}
                />
            );
        } else {
            return (
                <div
                    className="app-item-box"
                    style={{ ...orderType.flex }}
                >
                    <div className="app-icon-container">
                        <div className="app-icon-content">
                            <AppForIcon src={item.image_src} />
                        </div>
                    </div>
                    <div className="app-name" style={{ ...orderType.appName }}>{item.name || item.label}</div>
                </div>
            );
        }
    };

    render() {
        const { item, connectDragSource, connectDropTarget, groupItem, isQuickLaunchAndAdaptive, activeTab, isOver } = this.props;
        const style = {};
        if (isQuickLaunchAndAdaptive) {
            style.height = '100%';
        }
        // 快速发起 常用应用的最近访问不需要拖拽 false
        const flag = isOver && !checkApp(groupItem).isQuickLaunch && activeTab !== APPGROUPCONSTANT.RECENTVISIT;
        return connectDragSource(
            connectDropTarget(
                <div
                    className={this.props.isDragging ? "dragging" : ""}
                    onClick={checkApp(item).isExternalLink ? () => { } : this.handleItemClick}
                    style={style}
                >
                    {/* 快速发起 常用应用的最近访问不需要拖拽 因此也没有拖拽效果 */}
                    {flag && <div className="app-item-placeholder" />}
                    {this.renderItem()}
                </div>,
            ),
        );
    }

}

AppItem = DragSource(DragTypes.APP_GROUP_ITEM, cardSource, function (connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    };
})(AppItem);
AppItem = DropTarget([DragTypes.APP_GROUP_ITEM, DragTypes.SIDE_CARD], cardTarget, function (
    connect,
    monitor,
) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
    };
})(AppItem);
AppItem = useOprArea(
    props => ({
        isShow: props.editable && !checkApp(props.groupItem).isQuickLaunch && props.activeTab !== APPGROUPCONSTANT.RECENTVISIT, // 快速发起不展示操作区
        needCheckbox: false,
        ...props,
    }),
    AppItem,
);
AppItem = withQuickLaunchArea(props => ({
    isShow: !props.editable,
    appData: props.item,
}))(AppItem);
export default connect(state => ({ themeType: state.appData.themeColor }), {
    setDraggingItems,
    setDraggingAppGroupItem,
})(AppItem);
